export interface CalculationRow {
  id: number | string;
  detector: number;
  cpm1: number;
  cpm2: number;
  cpm3: number;
  cpm4: number;
}
export const initialRowsCalculation: CalculationRow[] = [
  {
    id: "NEW_1",
    detector: 1,
    cpm1: 0,
    cpm2: 0,
    cpm3: 0,
    cpm4: 0,
  },
  {
    id: "NEW_2",
    detector: 2,
    cpm1: 0,
    cpm2: 0,
    cpm3: 0,
    cpm4: 0,
  },
  {
    id: "NEW_3",
    detector: 3,
    cpm1: 0,
    cpm2: 0,
    cpm3: 0,
    cpm4: 0,
  },
  {
    id: "NEW_4",
    detector: 4,
    cpm1: 0,
    cpm2: 0,
    cpm3: 0,
    cpm4: 0,
  },
  {
    id: "NEW_5",
    detector: 5,
    cpm1: 0,
    cpm2: 0,
    cpm3: 0,
    cpm4: 0,
  },
  {
    id: "NEW_6",
    detector: 6,
    cpm1: 0,
    cpm2: 0,
    cpm3: 0,
    cpm4: 0,
  },
  {
    id: "NEW_7",
    detector: 7,
    cpm1: 0,
    cpm2: 0,
    cpm3: 0,
    cpm4: 0,
  },
  {
    id: "NEW_8",
    detector: 8,
    cpm1: 0,
    cpm2: 0,
    cpm3: 0,
    cpm4: 0,
  },
  {
    id: "NEW_9",
    detector: 9,
    cpm1: 0,
    cpm2: 0,
    cpm3: 0,
    cpm4: 0,
  },
  {
    id: "NEW_10",
    detector: 10,
    cpm1: 0,
    cpm2: 0,
    cpm3: 0,
    cpm4: 0,
  },
];
